import React, { useEffect } from 'react'
import "./TabbedNode.scss"
import "./Nodes.scss"
import { TabbedNodeDefaults, TabNodeDataInterface } from './TabNodeLayoutData';
import { Node} from "@jsplumbtoolkit/core"

export interface JsxContext {
    vertex: Node;           // the vertex - node or group - that is being rendered by this JSX
    surface: any;               // the Surface widget that is rendering the vertex
    toolkit: any;        // the underlying JsPlumbToolkit instance
    data: Record<string, any>;      // the vertex's backing data. This is just a convenience - it can be accessed via `vertex.data`
    props: Record<string, any>;     // these are any props that you passed in as the `childProps` argument to a `JsPlumbToolkitSurfaceComponent`. See below.    
}
export default function TabbedNode(props:{ctx:JsxContext, data:TabNodeDataInterface}) {
    
    const { vertex , toolkit} = props.ctx;
    const data = props.data; 

    if (data.type && data.type==="message") {
        
    }
    const targetEdges = toolkit.getAllEdges().map(e=>e.target.id);
    // const targetEdges = vertex.getPortTargetEdges(); 
    const sourceEdges = vertex.getPortSourceEdges().map(e=>e.source.id);
    return( 
        <div className="TabbedNode" 
        data-jtk-port-id={data.id}
        data-jtk-port-type="target"
        data-jtk-target={data.layout.hideInput ? "false" : "true"}

        style={{ width:data.layout.width +"px", height:data.layout.height +"px"}}>
                <svg width={data.layout.width} height={data.layout.height}><path d={data.layout.path} /></svg>
                <div className="tabbedContent"  style={{ width:data.layout.width +"px", height:data.layout.contentHeight +"px"}}  >


                    {data.layout.hideInput ? 
                       <div  style={{ width:data.layout.width +"px", height:TabbedNodeDefaults.noInputHeight +"px"}}
                        />
                           :
                        <div  style={{ width:data.layout.width +"px", height:TabbedNodeDefaults.inputHeight +"px"}}
                            className="nodeInput"
                            data-jtk-port-id={data.id}
                            data-jtk-port-type="target"
                            data-jtk-target="true" 
                

                         >
                            <div className="nodePort target" 
                      
                            
                            
                            ><div className={targetEdges && targetEdges.includes(data.id) ? "nodePortCircle connected" : "nodePortCircle"}   /></div>
                        </div>
                    }

                    {data.layout.label &&   <div className="label" style={{ width:data.layout.width +"px", height:TabbedNodeDefaults.labelHeight +"px"}}>{data.layout.label}</div>}
                    {data.layout.title &&   <div className="title" style={{ width: data.layout.width +"px", height:(data.layout.titleHeight || TabbedNodeDefaults.titleHeight) +"px"}}>{data.layout.title}</div>}
                 
                    {data.layout.imageURL && < div className="image" style={{width:data.layout.width+"px", height:TabbedNodeDefaults.imageHeight +"px"}} > <img src={data.layout.imageURL} alt="Media" /> </div>}

                    {data.layout.body &&    <div className="body"  style={{ width:data.layout.width +"px", height:data.layout.bodyHeight +"px"}}>{data.layout.body}</div>}
                </div>

                {data.layout.tabs && <div style={{ width:data.layout.width +"px", height:data.layout.tabHeight +"px"}} className="tabs">
                    { data.layout.tabs.map((tab, index) => {
                        return <div key={tab.id} className="tab source" style={{
                                    left: ((data.layout.tabWidth * index) + (TabbedNodeDefaults.tabMargin * index) )+ "px",
                                    width:data.layout.tabWidth+"px", 
                                    height:data.layout.tabHeight +"px" }} >


                                {tab.imageURL && < div className="tabImage" style={{width:data.layout.tabWidth+"px", height:TabbedNodeDefaults.tabImageHeight +"px"}} > <img src={tab.imageURL} alt="Card" /> </div>}

                                {tab.title && <div className={"title"} style={{ width:data.layout.tabWidth+"px", height:TabbedNodeDefaults.tabTitleHeight +"px", bottom:TabbedNodeDefaults.tabPortHeight +"px"  }}>{tab.title}</div>}
                             
                                    <div className="nodePort"
                                        style={{ width:data.layout.tabWidth+"px", height:TabbedNodeDefaults.tabPortHeight +"px" }}
                                        data-jtk-port={tab.source}
                                        data-jtk-source="true"
                                        data-jtk-port-type="source"
                                    >
                                    <div className={sourceEdges && sourceEdges.includes(tab.source) ? "nodePortCircle connected" : "nodePortCircle "}  />
                                </div>
                        </div>;
                    })}
                </div>}



        </div>)

}